'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import {
  useMaterialSelection,
  Bc,
  Ic,
  Lc,
  zc,
  Rc,
  Pc,
  Fc,
  Vc,
} from './collection-line-plan';
import { ArtifactStatus, IllustrativeBadge, bs } from './playback-controls';
import {
  Scene_ks,
  CollectionReveal,
  V,
  Ss,
  Ps,
  Scene_js,
  Scene_As,
} from './collection-artifact-primitives';
export function CollectionMaterials({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let [t, n] = useMaterialSelection(Bc),
    r = (t) => e >= Ic + t * Lc,
    i = (t) => e >= Ic + t * Lc + 380;
  return (
    <div className={'flex h-full flex-col'}>
      <ArtifactStatus
        icon={'swatch'}
        title={translateShowcaseNode(
          showcaseCopy,
          'LISI\xC8RE FW27 colour and material plan'
        )}
        done={e >= zc}
        working={'Assigning materials'}
        doneLabel={'Plan saved'}
      />
      <div className={'flex flex-1 flex-col gap-4 p-3 sm:p-5 md:gap-5 md:p-6'}>
        <div>
          <div className={'flex items-baseline justify-between'}>
            <Scene_ks className={'flex items-center gap-2'}>
              {translateShowcaseNode(showcaseCopy, 'Palette and R1 cloths')}
              <IllustrativeBadge className={'max-sm:hidden'} />
            </Scene_ks>
            <CollectionReveal
              as={'span'}
              on={e >= Rc}
              y={2}
              className={'num text-ink-4 text-[12px]'}
            >
              {translateShowcaseNode(showcaseCopy, V.length)}
              {translateShowcaseNode(showcaseCopy, ' products \xB7 ')}
              {translateShowcaseNode(showcaseCopy, Ss.length)}
              {translateShowcaseNode(showcaseCopy, ' materials \xB7')}
              {translateShowcaseNode(showcaseCopy, ' ')}
              {translateShowcaseNode(showcaseCopy, bs.length)}
              {translateShowcaseNode(showcaseCopy, ' colours')}
            </CollectionReveal>
          </div>
          <div
            className={
              'mt-2 flex h-10 overflow-hidden rounded-[10px] shadow-[inset_0_0_0_1px_var(--img-outline)]'
            }
          >
            {translateShowcaseNode(
              showcaseCopy,
              bs.map((t, n) => (
                <span
                  key={t.name}
                  className={
                    'flex h-full flex-1 origin-left items-end px-2 pb-1.5 transition-[transform,opacity] duration-[520ms] ease-[var(--ease)]'
                  }
                  style={{
                    backgroundColor: t.hex,
                    transform: e >= Pc + n * 100 ? 'none' : 'scaleX(0)',
                    opacity: +(e >= Pc + n * 100),
                  }}
                >
                  <span
                    className={
                      'truncate text-[11px] leading-none font-medium max-sm:hidden'
                    }
                    style={{
                      color: Ps(t.hex),
                    }}
                  >
                    {translateShowcaseNode(showcaseCopy, t.name)}
                  </span>
                </span>
              ))
            )}
          </div>
        </div>
        <div ref={t} className={'cf-assign relative grid flex-1'}>
          <svg
            aria-hidden={!0}
            className={
              'pointer-events-none absolute inset-0 size-full overflow-visible'
            }
          >
            {translateShowcaseNode(
              showcaseCopy,
              n.map((e, t) => (
                <g key={e.to} className={'text-ink-4'}>
                  <path
                    d={e.d}
                    pathLength={1}
                    fill={'none'}
                    stroke={'currentColor'}
                    strokeWidth={'1.25'}
                    strokeLinecap={'round'}
                    strokeDasharray={'1 2'}
                    strokeDashoffset={+!r(t)}
                    style={{
                      transition: r(t)
                        ? 'stroke-dashoffset 420ms var(--ease)'
                        : 'none',
                    }}
                  />
                  <circle
                    cx={e.end.x}
                    cy={e.end.y}
                    r={'2.5'}
                    fill={'currentColor'}
                    className={'transition-opacity duration-200'}
                    style={{
                      opacity: +!!i(t),
                    }}
                  />
                </g>
              ))
            )}
          </svg>
          <ul className={'flex flex-col justify-center gap-5 md:gap-3'}>
            {translateShowcaseNode(
              showcaseCopy,
              Ss.map((t, n) => {
                let r = V.filter((e, n) => e.material === t.key && i(n)).length;
                return (
                  <CollectionReveal
                    key={t.key}
                    as={'li'}
                    on={e >= Fc + n * 120}
                    className={'min-w-0'}
                  >
                    <span
                      data-anchor={`mat-${t.key}`}
                      className={
                        'flex min-w-0 items-center gap-2.5 max-md:flex-col max-md:items-stretch max-md:gap-1'
                      }
                    >
                      <span
                        className={`cf-weave cf-weave-${t.weave} size-10 shrink-0 rounded-[9px] max-md:h-8 max-md:w-full`}
                        style={{
                          backgroundColor: Vc(t.key),
                        }}
                      />
                      <span className={'min-w-0'}>
                        <span
                          className={
                            'text-ink block truncate text-[12.5px] leading-4 font-medium max-md:text-[11px]'
                          }
                        >
                          <span className={'md:hidden'}>
                            {translateShowcaseNode(showcaseCopy, t.short)}
                          </span>
                          <span className={'max-md:hidden'}>
                            {translateShowcaseNode(showcaseCopy, t.name)}
                          </span>
                        </span>
                        <span
                          className={
                            'num text-ink-4 block text-[11px] leading-4 max-md:hidden'
                          }
                        >
                          {translateShowcaseNode(showcaseCopy, r)}
                          {translateShowcaseNode(showcaseCopy, ' ')}
                          {translateShowcaseNode(
                            showcaseCopy,
                            r === 1 ? 'product' : 'products'
                          )}
                        </span>
                      </span>
                    </span>
                  </CollectionReveal>
                );
              })
            )}
          </ul>
          <ul className={'flex flex-col justify-center gap-3 md:gap-2'}>
            {translateShowcaseNode(
              showcaseCopy,
              V.map((t, n) => {
                let r = Ss.find((e) => e.key === t.material);
                return (
                  <li
                    key={t.name}
                    className={'flex min-w-0 items-center gap-2.5'}
                  >
                    <span data-anchor={`prod-${n}`} className={'shrink-0'}>
                      <Scene_js
                        piece={t}
                        className={`size-11 rounded-[9px] transition-opacity duration-300 md:size-9 md:rounded-[8px] ${i(n) || e < Ic ? '' : 'opacity-50'}`}
                      />
                    </span>
                    <span className={'min-w-0 flex-1'}>
                      <span
                        className={
                          'text-ink block truncate text-[12.5px] leading-4 font-medium'
                        }
                      >
                        {translateShowcaseNode(showcaseCopy, t.style)}
                      </span>
                      <span className={'relative block h-4'}>
                        <CollectionReveal
                          as={'span'}
                          on={i(n)}
                          y={3}
                          blur={2}
                          className={
                            'text-ink-3 absolute inset-0 flex items-center gap-1.5 text-[11.5px] leading-4'
                          }
                        >
                          <Scene_As hex={t.colour.hex} className={'size-2'} />
                          <span className={'truncate'}>
                            {translateShowcaseNode(showcaseCopy, t.colour.name)}
                            <span className={'max-sm:hidden'}>
                              {translateShowcaseNode(showcaseCopy, ' ')}
                              {translateShowcaseNode(showcaseCopy, '\xB7 ')}
                              {translateShowcaseNode(showcaseCopy, r?.name)}
                            </span>
                          </span>
                        </CollectionReveal>
                      </span>
                    </span>
                  </li>
                );
              })
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}
export const Uc = 13;
export const Wc = 120;
export const Gc = [
  {
    piece: 0,
    fields: [
      ['Purpose', 'Anchors the capsule and the campaign.'],
      ['Customer', 'Wears tailoring daily; buys one coat a season.'],
      ['Idea', 'Taupe stock cloth, soft shoulder, edge line at the hem.'],
    ],
  },
  {
    piece: 3,
    fields: [
      ['Purpose', 'Carries Oxblood, the line\u2019s only accent.'],
      ['Customer', 'Layers knitwear under tailoring.'],
      ['Idea', 'A soft crew cardigan finished with the edge line.'],
    ],
  },
  {
    piece: 5,
    fields: [
      ['Purpose', 'The second tailored layer, lighter than the coat.'],
      ['Customer', 'Wants polish without structure.'],
      ['Idea', 'Unstructured Ink jacket in a stock cloth.'],
    ],
  },
];
export const Kc = [300, 1e3, 1700];
export const qc = (e) => e.length * Uc + Wc;
export function Jc(e, t) {
  let n = t + 380;
  return {
    starts: e.fields.map(([, e]) => {
      let t = n;
      return ((n += qc(e)), t);
    }),
    end: n,
  };
}
export const Yc = Gc.map((e, t) => Jc(e, Kc[t] ?? 0));
export const Xc = Yc[Yc.length - 1]?.end ?? 4e3;
export const Zc = Xc + 900;
export function Qc(e) {
  let t = Yc[Gc.findIndex((t) => t.piece === e)];
  if (t) return t.end;
  let n = V.map((e, t) => t).filter((e) => !Gc.some((t) => t.piece === e));
  return Xc + 150 + n.indexOf(e) * 160;
}
